// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zhSwo","col":"styles_col__Tfyxb"};